"use client";

import React from "react";
import { Mail, MapPin, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuLinks() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-3">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-5 w-24 bg-primary/5 animate-pulse rounded-md" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) return null;
  return <ul className="flex flex-col gap-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors text-sm font-medium">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <section id="footer" className="bg-background border-t border-primary/20 pt-16 pb-8">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8 mb-12">
          
          {}
          <div className="flex flex-col items-start gap-6">
            <Link to="/" className="block">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1554289/img/verifidie_logo_footer.png" alt="Verifidie" className="h-14 w-auto object-contain" />
            </Link>
            <p className="text-primary font-serif text-xl italic leading-relaxed">Feel It, Check It, Seal It</p>
          </div>

          {}
          <div className="flex flex-col gap-4">
            <h3 className="text-primary font-semibold tracking-wide uppercase text-sm">
              Explore
            </h3>
            <MenuProvider menu_id="18" className="w-full">
              <FooterMenuLinks />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col gap-4">
            <h3 className="text-primary font-semibold tracking-wide uppercase text-sm">
              Contact
            </h3>
            <div className="flex flex-col gap-3">
              <Link to="tel:+919718285422" className="flex items-center gap-3 text-muted-foreground hover:text-primary transition-colors group">
                <div className="flex items-center justify-center size-8 rounded-full bg-primary/5 group-hover:bg-primary/10 transition-colors shrink-0">
                  <Phone className="size-4 text-primary" />
                </div>
                <span className="text-sm">+91 9718285422</span>
              </Link>
              <Link to="mailto:contact@verifidie.com" className="flex items-center gap-3 text-muted-foreground hover:text-primary transition-colors group">
                <div className="flex items-center justify-center size-8 rounded-full bg-primary/5 group-hover:bg-primary/10 transition-colors shrink-0">
                  <Mail className="size-4 text-primary" />
                </div>
                <span className="text-sm">contact@verifidie.com</span>
              </Link>
            </div>
          </div>

          {}
          <div className="flex flex-col gap-4">
            <h3 className="text-primary font-semibold tracking-wide uppercase text-sm">
              Location
            </h3>
            <div className="flex items-start gap-3 text-muted-foreground group">
              <div className="flex items-center justify-center size-8 rounded-full bg-primary/5 group-hover:bg-primary/10 transition-colors shrink-0 mt-0.5">
                <MapPin className="size-4 text-primary" />
              </div>
              <span className="text-sm leading-relaxed">
                New Delhi, India
              </span>
            </div>
          </div>

        </div>

        <Separator className="bg-primary/10 mb-8" />

        {}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-muted-foreground">
          <p>
            &copy; {currentYear} Verifidie. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link to="#" className="hover:text-primary transition-colors">
              Confidentiality Agreement
            </Link>
            <Link to="#" className="hover:text-primary transition-colors">
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </section>;
}